module.exports = __webpack_public_path__ + "img/在线订货，便捷安心ico.9b5c05bd.png";